/* 播放视频的组件*/
<template>
  <div>
    <div id="video-container">
      <video
        id="player-container-id"
        preload="auto"
        playsinline
        webkit-playsinline
      ></video>
    </div>
  </div>
</template>
<script>
export default {
  name: "my-video",
  props: ["fid", "aid","playData","isplay"],
  data() {
    return {
      // getPlayer:{},
      player: null,
    };
  },
  methods: {
    handler(val) {
      this.$emit("handler", val);
    },
    getPlayer(){
      return this.player
    },
    init() {
      this.initPlayer()
    },
    initPlayer(){
      if(typeof TCPlayer == "undefined"){
        setTimeout(() =>{
          this.initPlayer()
        },500)
        return
      }
      var fileID = this.playData.file_id
      if(typeof fileID == 'undefined'){
          return
      }
      fileID = fileID.toString()
      var swf = '//vod2.gaokaozhitongche.com/vod-player/' + this.playData.appid + '/' + fileID + '/tcplayer/player.swf'
      
      this.player = TCPlayer("player-container-id", {
        // autoplay: true,
        fileID: fileID,
        appID: this.playData.appid,
        // playDefinition: '10',
        t: this.playData.timeout,
        us: this.playData.us,
        sign: this.playData.sign,
        flash: {
          swf: swf
        },
        plugins:{
          ContinuePlay: { // 开启续播功能
            // auto: true, //[可选] 是否在视频播放后自动续播
            // text:'上次播放至 ', //[可选] 提示文案
            // btnText: '恢复播放' //[可选] 按钮文案
          },
        }

      });
      let vm = this;
      this.player.on("play", function() {
        vm.handler(true);
      });
      this.player.on("pause", function() {
        vm.handler(false);
      });
      //   return this.getPlayer=player;
    },
    changePlayer(playData){
      var fileID = playData.file_id
      if(typeof fileID == 'undefined'){
          return
      }
      fileID = fileID.toString()
      var swf = '//vod2.gaokaozhitongche.com/vod-player/' + playData.appid + '/' + fileID + '/tcplayer/player.swf'
      console.log(swf)
      this.getPlayer().loadVideoByID({
        // autoplay: true,
        fileID: fileID,
        appID: playData.appid,
        // playDefinition: '10',
        t: playData.timeout,
        us: playData.us,
        sign: playData.sign,
        flash: {
          swf: swf
        },
        plugins:{
          ContinuePlay: { // 开启续播功能
            // auto: true, //[可选] 是否在视频播放后自动续播
            // text:'上次播放至 ', //[可选] 提示文案
            // btnText: '恢复播放' //[可选] 按钮文案
          }
        }
      });
    }
  },
  created() {},
  mounted() {
    // this.init()
    // this.getplayer=this.init();
  },
  beforeDestroy() {
    // 销毁点播
    this.player&&this.player.dispose();
  }
};
</script>
<style scoped>
html,
body {
  margin: 0;
  padding: 0;
}
.tcplayer {
  margin: 0 auto;
}
@media screen {
  #player-container-id {
    width: 100%;
    /* height: 210px; */
    /* height: 10.5rem; */
    height: calc(100vw * 210 / 375);
    max-height: calc(768px * 210 / 375);
    /* height: auto; */
    overflow: auto;
    text-align: center;
  }
  .blank {
    height: 210px;
  }
}
/* 设置logo在高分屏的显示样式 */
@media only screen and (min-device-pixel-ratio: 2),
  only screen and (-webkit-min-device-pixel-ratio: 2) {
  .tcp-logo-img {
    width: 50%;
  }
}

.playActive {
  position: fixed;
  width: 100%;
  height: auto;
  /* overflow: auto; */
  z-index: 999;
}
</style>
